import React, { useState } from 'react';

import { SelectedFacetsToApplyProvider } from '../../hooks/useSelectedFacetsToApply';

import MobileGridFiltersPane from './MobileGridFiltersPane';

const MobileGridFilters = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <div className="">
      <button
        type="button"
        className="underline"
        onClick={() => setShowOverlay((show) => !show)}
      >
        Filter {'>'}
      </button>
      {showOverlay && (
        <button
          type="button"
          className="fixed top-0 left-0 w-full h-full bg-gray-700 opacity-50 z-10 transition-opacity duration-300"
          onClick={() => setShowOverlay(false)}
        />
      )}
      <div
        className={`fixed top-0 ${
          showOverlay ? 'right-0' : 'left-[100%]'
        } w-[280px] h-full bg-white z-20 transition-transform duration-300`}
      >
        <SelectedFacetsToApplyProvider>
          <MobileGridFiltersPane setShowOverlay={setShowOverlay} />
        </SelectedFacetsToApplyProvider>
      </div>
    </div>
  );
};

export default MobileGridFilters;
